import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOffline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 110,
	height: 110,
	viewBox: "0 0 110 110",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M55.1243 109.006C84.8591 109.006 109.007 84.8586 109.007 55.1238C109.007 25.3891 84.8591 1.24121 55.1243 1.24121C25.3896 1.24121 1.2417 25.3891 1.2417 55.1238C1.2417 84.9207 25.3896 109.006 55.1243 109.006Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 55.2487,
			cy: 55.2477,
			r: 39.7291,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.4543 87.9027C73.3753 87.9027 87.9032 73.3748 87.9032 55.4538C87.9032 37.5328 73.3753 23.0049 55.4543 23.0049C37.5332 23.0049 23.0054 37.5328 23.0054 55.4538C23.0054 73.3748 37.5332 87.9027 55.4543 87.9027Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.4546 23.0049V87.9029C73.3756 87.9029 87.9035 73.375 87.9035 55.454C87.9035 37.5328 73.3756 23.0049 55.4546 23.0049Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.4545 19.2432C35.4881 19.2432 19.2441 35.4871 19.2441 55.4535C19.2441 75.4199 35.4881 91.6638 55.4545 91.6638L62.9937 87.9026L57.4652 85.0763V27.581L61.6565 23.599L55.4545 19.2432ZM51.9095 27.5812V42.0334H43.9207C44.6611 39.043 45.6455 36.332 46.8512 33.9642C48.3428 31.0349 50.0755 28.8538 51.9095 27.5812ZM51.9095 49.1232V61.784H42.6927C42.4754 59.7188 42.3652 57.5921 42.3652 55.4537C42.3652 53.3153 42.4752 51.1886 42.6927 49.1234L51.9095 49.1232ZM51.9095 68.8736V83.326C50.0753 82.0532 48.3428 79.8721 46.8514 76.9428C45.6457 74.575 44.6613 71.864 43.9209 68.8736H51.9095ZM29.6148 42.0334C32.151 37.1721 36.033 33.0984 40.7521 30.3246C40.6785 30.4646 40.6056 30.6053 40.5334 30.7469C38.8551 34.0428 37.5499 37.8375 36.6508 42.0332H29.6148V42.0334ZM36.6508 68.8736C37.5499 73.0693 38.8551 76.864 40.5334 80.1599C40.6056 80.3015 40.6785 80.4424 40.7521 80.5822C36.033 77.8086 32.1508 73.7347 29.6148 68.8734H36.6508V68.8736ZM35.5705 61.7838H27.027C26.567 59.7155 26.3339 57.5885 26.3339 55.4535C26.3339 53.3185 26.567 51.1915 27.027 49.1232H35.5705C35.3748 51.2018 35.2757 53.3277 35.2757 55.4535C35.2757 57.5793 35.3748 59.7052 35.5705 61.7838Z",
			fill: "#1DBADF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.4546 19.2432V91.6636C75.421 91.6636 91.6649 75.4197 91.6649 55.4533C91.6649 35.4869 75.421 19.2432 55.4546 19.2432ZM81.2941 42.0334H74.2581C73.359 37.8375 72.0538 34.0428 70.3754 30.7471C70.3033 30.6055 70.2305 30.4646 70.1568 30.3248C74.8758 33.0984 78.7578 37.1721 81.2941 42.0334ZM58.9994 27.581C60.8336 28.8538 62.566 31.0349 64.0575 33.9642C65.2632 36.3316 66.2476 39.0428 66.988 42.0334H58.9994V27.581ZM64.0577 76.9428C62.5662 79.8721 60.8338 82.0532 58.9996 83.326V68.8736H66.9882C66.2478 71.8644 65.2632 74.5754 64.0577 76.9428ZM68.2162 61.7838H58.9994V49.123H68.2162C68.4336 51.188 68.5437 53.3145 68.5437 55.4533C68.5437 57.5923 68.4336 59.7188 68.2162 61.7838ZM70.1568 80.5824C70.2305 80.4426 70.3033 80.3017 70.3754 80.1601C72.0538 76.8642 73.359 73.0695 74.2581 68.8738H81.2941C78.7578 73.7349 74.8758 77.8088 70.1568 80.5824ZM75.3385 61.7838C75.5343 59.706 75.6334 57.58 75.6334 55.4535C75.6334 53.327 75.5343 51.201 75.3385 49.1232H83.882C84.3421 51.1921 84.5752 53.3189 84.5752 55.4535C84.5752 57.5881 84.3421 59.7151 83.882 61.7838H75.3385Z",
			fill: "#1DBADF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5895 91.0994L19.8086 84.3185L55.4543 48.6729L59.1219 52.3119L55.4543 62.2346L26.5895 91.0994Z",
			fill: "#FF2180"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.1003 26.5885L84.3194 19.8076L55.4546 48.6724V62.2342L91.1003 26.5885Z",
			fill: "#FF2180"
		})
	]
});
export default SvgOffline;
